module.exports = __webpack_public_path__ + "4acaf799500dd881e7fb4fe2ae04c9ec.MP3";